export default "__VITE_ASSET__CcD44Bzs__"